<template>
  <!-- <div> -->
  <Dropdown
    :style="{width: '100%', position: 'relative'}"
    :transfer="options.transfer"
    :transfer-class-name="options.transferClassName"
    :visible="visible"
    class="customDrop"
    ref="dropRefionRef"
    trigger="custom"
  >
    <div class="regionInput">
      <slot name="treeSelectLabel"></slot>
      <div style="flex-grow: 1;">
        <Input
          :placeholder="placeholder"
          :title="name"
          @on-clear="clear"
          @on-click="handleOpen"
          @on-focus="handleOpen"
          clearable
          icon="ios-arrow-down"
          readonly
          type="text"
          v-model="name"
        >
          <!-- <Icon type="ios-arrow-down" slot="suffix" /> -->
        </Input>
      </div>
    </div>
    <DropdownMenu slot="list">
      <div class="regionPanel">
        <Spin fix v-show="loading">加载中...</Spin>
        <Tree
          :data="subAreas"
          :load-data="loadData"
          :loading="loading"
          :render="renderContent"
          :style="{width: options.width}"
          @on-select-change="changeNode"
          class="selfTree"
        ></Tree>
      </div>
    </DropdownMenu>
  </Dropdown>
  <!-- </div> -->
</template>
<script>
export default {
  name: 'regionTreeSelect',
  props: {
    opts: {
      required: false,
      default: function () {
        return {}
      }
    },
    defaultValue: {
      required: false,
      default: function () {
        return {
          value: null,
          name: ''
        }
      }
    },
    placeholder: {
      required: false,
      default: '请选择所属区域'
    },
  },
  data () {
    return {
      options: {
        transferClassName: 'fitContainer',
        transfer: false
      },
      loading: false,
      subAreas: [],
      visible: false,
      selectData: null,
      name: ''
    }
  },
  watch: {
    opts: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.options = Object.assign(this.options, newValue)
      }
    },
    defaultValue: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.name = newValue?.name
        this.selectData = newValue?.value
      }
    },
  },
  methods: {
    renderContent (h, { root, node, data }) {
      return h('span', data.name)
    },
    close: function () {
      this.visible = false
    },
    handleOpen: function () {
      this.visible = true
    },
    clear: function () {
      this.selectData = null
      this.name = ''
      this.$emit('change', null)
    },
    outClick (e) {
      let dropRefionRef = this.$refs.dropRefionRef.$el
      if (!dropRefionRef.contains(e.target) && this.visible) {
        this.visible = false
      }
    },
    getLabel: function () {
      console.log('getL', this.regionNamesMap)
      this.name = this.regionNamesMap[this.value]
    },
    changeNode: function (selectValue, current) {
      if (selectValue && selectValue.length > 0) {
        this.name = selectValue[0].name
        this.$emit('change', selectValue[0])
      } else {
        this.name = ''
        this.$emit('change', null)
      }
      this.close()
    },
    search: function (fullCode, callback) {
      let that = this

      let params = new this.$URLSearchParams()
      if (fullCode) params.append("fullCode", fullCode)
      this.$axios.get(that.$apis.dictionaryManager.region.subTreeByFullCode + "?fullCode=" + fullCode).then(res => {
        if (res.success) {
          if (callback) {
            callback(res.result || [])
          } else {
            that.subAreas = [{
              name: '全国',
              expand: true,
              type: 'country',
              code: '000000000000',
              loading: false,
              children: res.result || []
            }]
          }

        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('区域树获取失败！')
      })
    },
    loadData: function (item, callback) {
      this.search(item.fullCode, callback)
    }
  },
  beforeMount () {
    this.search("000000000000")
    this.close()
    document.getElementsByTagName("body")[0].addEventListener('click', this.outClick)
  },
  beforeDestroy () {
    this.close()
    document.getElementsByTagName("body")[0].removeEventListener('click', this.outClick)
  }
}
</script>
<style lang='less' scoped>
.regionInput {
  color: #6c6c6c;
  padding: 8px;
  display: flex;
  align-items: center;
}
.regionPanel {
  /* height: 50vh; */
  /* overflow-y: auto; */
  padding: 0 1rem;
  min-height: 100px;
  min-width: 100px;
  max-height: 300px;
  overflow: auto;
  max-width: 80vw;

  .ivu-tree ul li {
    margin: 4px 0;
  }
}
</style>
